import { gql } from 'app/graphql';

export const CREATE_NEW_LISTING_ACTIVITY_NOTIFICATION = gql(`
    mutation CreateNewListingActivityNotification($input: ListingActivityInput!){
        notifications {
            events {
                newListingActivity(input: $input) {
                    id
                }
            }
        }
    }
`);

export const CREATE_LISTING_ACTIVITY_CHANGED_NOTIFICATION = gql(`
    mutation CreateListingActivityChangedNotification($input: ListingActivityInput!){
        notifications {
            events {
                changedListingActivity(input: $input) {
                    id
                }
            }
        }
    }
`);

export const CREATE_LISTING_ACTIVITY_REMOVED_NOTIFICATION = gql(`
    mutation CreateListingActivityRemovedNotification($input: NotificationRemoveListingActivityInput!) {
        notifications {
            events {
                removeListingActivity(input: $input) {
                    id
                }
            }
        }
    }
`);

export const CREATE_EXTERNAL_LISTING_ADDED_NOTIFICATION = gql(`
    mutation CreateExternalListingAddedNotification($input: ExternalListingEventInput!){
        notifications {
            events {
                externalListingAdded(input: $input) {
                    id
                }
            }
        }
    }
`);

export const CREATE_EXTERNAL_LISTING_REMOVED_NOTIFICATION = gql(`
    mutation CreateExternalListingDeletedNotification($input: ExternalListingDeletedEventInput!){
        notifications {
            events {
                externalListingDeleted(input: $input) {
                    id
                }
            }
        }
    }
`);

export const CREATE_LISTING_HARD_DELETED_NOTIFICATION = gql(`
    mutation CreateListingHardDeletedNotification($input: ListingsRemovedEventInput!){
        notifications {
            events {
                listingHardDeleted(input: $input) {
                    id
                }
            }
        }
    }
`);

export const CREATE_LISTING_SHARED_NOTIFICATION = gql(`
    mutation CreateListingSharedNotification($input: ListingSharedEventInput!){
        notifications {
            events {
                listingShared(input: $input) {
                    id
                }
            }
        }
    }
`);